module.exports = "/images/home-banner-2.png";